<template>
    <button
        type="button"
        @click="$emit('click')"
    >
        <svg><use xlink:href="@/themes/novaporta/assets/icons/sprite.svg#informationalIcon"></use></svg>
    </button>
</template>

<script>
export default {
    name: 'ButtonInfo',
}
</script>

<style lang="scss" scoped>
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
